// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.marking-teacher[data-v-bafccd94] {\n  cursor: pointer;\n}\n.marking-teacher[data-v-bafccd94]:hover {\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
